import Layout from '../layouts/Layout';
import { NextSeo } from 'next-seo';

const Refund = () => (
    <Layout>
        {
            process.env.NEXT_PUBLIC_ENV === 'production' &&
            <NextSeo 
                title='Refund Policy'
                titleTemplate='Collegify | %s'
                copyright='Collegify has copyrights to all the content on the page.'
                keywords="refund,payment,guranteed cashback"
                description="Collegify's Refund Policy"
                openGraph={{
                    url: process.env.NEXT_PUBLIC_APP_URI + "/refund",
                    title: 'Collegify | Refund Policy',
                    type: 'website',
                    locale: 'en_US',
                    description: "Collegify's Refund Policy",
                    images: [
                        {
                            url: process.env.NEXT_PUBLIC_FILE_URI + 'social-banner/refund-policy.jpg',
                            width: 500,
                            height: 500,
                            alt: 'Interactive Platform for Adaptive Learning',
                        },
                    ],
                    site_name: 'Collegify',
                }}
            />
        }
        <section id="refund" className="py-5 nav-margin">
            <div className="container px-4 intro-content">
                <h2 className="fw-bolder text-center mb-4">Refund Policy</h2>
                <p className="mb-4">CG Collegify Pvt. Ltd. (hereinafter referred to as “Collegify/We/Us") respects and protects the users of Collegify’s services. This policy details our principles on refund. The Refund Policy shall be read along with the Privacy Policy and Terms of Use, as detailed on our Website www.collegify.com. As a user, you are responsible for understanding that Collegify offers intangible and irrevocable services to its users before engaging our services. As such, we do not issue any refunds once the transaction has taken place.</p>
                <h4 className="fw-bolder mb-2">Acceptance of this Refund Policy</h4>
                <p className="mb-4">This no refund policy is hereby communicated to users to prevent misunderstanding and disputes. It is your responsibility to familiarize yourself with this Refund Policy. By placing an order for any of our services, you indicate that you have read this refund policy and that you agree with and fully accept the terms of this Refund Policy. If you do not agree with or fully accept the terms of this Refund Policy, we request you to not transact through our Website for our services. If there is any error attributable to you or us including but not limited to a technical issue while transacting through our website, please contact customer service at <strong>+911141666662</strong> or email us at <strong>info@collegify.com.</strong></p>
            </div>
        </section>
    </Layout>
)

export default Refund
